import axios from "axios";
import { Toast } from 'vant';
import Cookies from 'js-cookie'
import { USER_TOKEN_COOKIES_KEY } from "@/utils/constant";
import { getAppID, isToufang } from "@/utils/base";
import { isAndroid, getParam } from '@/utils/tools'
import SignUtil from '@/utils/sign'

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000,
  isSign: true,
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.data = {
    ...config.data || {},
    app_id: getAppID()
  }
  if(config.isSign === true){
    config.data.sign = SignUtil.generateSign(config.data);
  }
  if(Cookies.get(USER_TOKEN_COOKIES_KEY)){
    config.headers.Authorization = `Bearer ${Cookies.get(USER_TOKEN_COOKIES_KEY)}`
  }
  config.headers.device = 'h5'
  config.headers.H5device = isAndroid() ? 'android' : 'ios'
  config.headers.adf = getParam('adf') || 0
  if(isToufang()){
    config.headers.Adfrom = 1
  }

  if(config.isToast !== false){
    Toast.loading({
      duration: 0,
    });
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  if(response.config.isClearToast !== 'none'){
    Toast.clear();
  }
  return response;
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  const errData = typeof error.response?.data === 'string'? JSON.parse(error.response?.data) : error.response?.data
  if(errData?.code !== 0){
    Toast({
      message: errData?.msg || 'Error',
    })
  }
  setTimeout(() => {
    Toast.clear();
  }, 1000);
  return Promise.reject(error);
});

export const request = function(options = {}){
  return new Promise((resolve, reject) => {
    axios.request({
      ...config,
      ...options
    }).then(res => {
      if(options.responseType === 'all'){
        resolve(JSON.parse(res.data))
        return
      }
      resolve(res.data.data)
    }).catch(err => {
      reject(err)
    })
  })
}
